import React, { useState } from "react";
import { useToast } from "./Toast";
import Dropzone from "react-dropzone";
import axios from "axios";
import { UPLOAD_TEMP_EVENT_IMAGE_API } from "../Constant/api";

const ImageUpload = ({ handleChange }) => {
  const { toast } = useToast();

  const handleUploadImage = (acceptedFiles) => {
    const formData = new FormData();
    formData.append("file", acceptedFiles[0]);
    axios
      .post(UPLOAD_TEMP_EVENT_IMAGE_API, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("bearer_token")}`,
        },
      })
      .then((res) => {
        handleChange(res.data.data.url);
        toast("Image uploaded successfully", "success");
      })
      .catch((err) => {
        console.log(err);
        toast("Failed to upload image", "error");
      });
  };

  const handleRejectedFiles = (rejectedFiles) => {
    rejectedFiles.forEach((file) => {
      if (file.errors.some((e) => e.code === "file-too-large")) {
        toast("File is too large. Maximum size is 5MB.", "error");
      } else {
        toast("File type not accepted.", "error");
      }
    });
  };

  return (
    <Dropzone
      onDropAccepted={handleUploadImage}
      onDropRejected={handleRejectedFiles}
      accept={{ "image/*": [".jpeg", ".png", ".gif", ".bmp", ".svg", ".jpg"] }}
      className="w-full h-full border-black"
      maxSize={2097152}
    >
      {({
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
      }) => {
        const additionalClass = isDragAccept
          ? "border-green-500"
          : isDragReject
          ? "border-red-500"
          : "border-[#EFF0F2]";

        return (
          <section className="flex w-full">
            <div
              {...getRootProps()}
              className={`flex flex-col border w-full h-[76px] justify-center items-center cursor-pointer rounded-lg ${additionalClass}`}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                isDragAccept ? (
                  <p className="text-[#636C7E] font-normal">
                    Drop the files here ...
                  </p>
                ) : (
                  <p className="text-[#636C7E] font-normal">
                    File type not accepted!
                  </p>
                )
              ) : (
                <p className="text-[#636C7E] font-normal">
                  Drag & Drop your files or{" "}
                  <span className="text-[#5C4BF5] font-medium">Browse</span>
                </p>
              )}
            </div>
          </section>
        );
      }}
    </Dropzone>
  );
};

export default ImageUpload;
